export const SKILLS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_title: "Private & Retail Banks",
    meta_priority: 1,
    meta_text_color: "#FFFFFF",
  },

  METADATA_TITLES: {
    metadata: "Skills",
  },

  SKILLS_FIELDS_CONFIG: [
    {
      fieldName: "design_variant",
      label: "Design Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select design variant",
      helperText:
        "Switches the design (colours, fonts, spacing). Variant 2 also shows the Download Brochure button.",
      required: false,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #02A7B6)",
      required: false,
      defaultValue: "#02A7B6",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "v2_pre_title_color",
      label: "Heading Color (Variant 2)",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_title_color",
      label: "Highlighted Heading Color (Variant 2)",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter highlighted heading color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_description_color",
      label: "Description Color (Variant 2)",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_pill_bg_color",
      label: "Pill Background Color (Variant 2)",
      value: "#FFF3F6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pill background color (e.g., #FFF3F6)",
      required: false,
      defaultValue: "#FFF3F6",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_pill_border_color",
      label: "Pill Border Color (Variant 2)",
      value: "rgba(159,28,52,0.7)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pill border color (e.g., rgba(159,28,52,0.7))",
      required: false,
      defaultValue: "rgba(159,28,52,0.7)",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_pill_text_color",
      label: "Pill Text Color (Variant 2)",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pill text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "download_brochure_text",
      label: "Download Brochure Text (Variant 2)",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Download Brochure button text",
      required: false,
      defaultValue: "Download Brochure",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "button_bg_color",
      label: "Button Background Color (Variant 2)",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color (Variant 2)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      helperText: "Also colors the download arrow icon.",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "button_shadow_color",
      label: "Button Shadow Color (Variant 2)",
      value: "rgba(202,125,139,0.6)",
      valueType: "string",
      // RGBA (not COLOR) — the shadow needs alpha, and ColorField's text input
      // only accepts hex.
      filedType: "RGBA",
      placeholder: "Enter button shadow color (e.g., rgba(202,125,139,0.6))",
      required: false,
      defaultValue: "rgba(202,125,139,0.6)",
      helperText: "Set opacity to 0 to remove the shadow.",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "status",
      label: "Skills Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Skills Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., Private & Retail Banks)",
      required: true,
    },
    {
      header: "Text Color",
      fieldName: "meta_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};
